/**
 * Collapsable navigation
 */

import '../../../js/vendor/polyfills/polyfill-closest.js';
import '../../../js/vendor/polyfills/polyfill-array-from.js';

// Import extend function.
import Component from '../../../js/core/component.js';
import Collapse from '../../../js/utilities/collapse/u-collapse.js';

class CollapsableNavigation extends Component {
	/**
	 * Default settings for this component
	 * @return {object} Default settings
	 */
	_defaultSettings () {
		return {
			debug: false,
			classNames: {
				hasChildren: 'has-children',
				collapsed: 'is-collapsed',
				expanded: 'is-expanded',
				toggle: 'c-collapsable-navigation__toggle'
			},
			selectors: {
				activeItem: '.is-active'
			},
			icons: null
		};
	}

	/**
	 * Initialize component
	 */
	_init () {
		// Exit if Collapsable Navigation already is inited
		if (this.inited) {
			this._log('Collapsable Navigation is already inited');
			return;
		}

		this.element = this.settings.element;

		this.items = this.element.querySelectorAll('li');

		this.items.forEach((item) => {
			if (item.querySelector('ul')) {
				let toggleButton = document.createElement('span');
				toggleButton.classList.add(this.settings.classNames.toggle);
				toggleButton.innerHTML = '';
				item.insertBefore(toggleButton, item.querySelector('ul'));
				item.classList.add(this.settings.classNames.hasChildren);

				item.collapse = new Collapse({
					element: item,
					selectors: {
						header: '> span',
						content: '> ul'
					},
					icons: this.settings.icons,
					classNames: {
						expanded: this.settings.classNames.expanded,
						collapsed: this.settings.classNames.collapsed
					},
					on: {
						collapse: () => {
							item.querySelectorAll('.has-children').forEach((item) => {
								item.collapse.collapse();
							});
						}
					},
					prepareCssAnimation: true
				});
			}
		});

		let activeItem = this.element.querySelector(this.settings.selectors.activeItem);
		if (activeItem) {
			let item = activeItem;
			let i = 0;
			while (item && i < 50) {
				item = item.parentNode.closest('.has-children');
				if (item) {
					item.collapse.expand();
				}
				i++;
			}
		}

		this._log(this.lists);
	}

	init () {
		this._init();
	}

	destroy () {
		this._log('destroy()');
		let items = this.element.querySelectorAll(`.${this.settings.classNames.hasChildren}`);
		if (items) {
			Array.from(items).reverse().forEach((item) => {
				let toggleButton = item.querySelector(`.${this.settings.classNames.toggleButton}`);
				if (toggleButton) {
					toggleButton.remove();
				}
				item.classList.remove(this.settings.classNames.hasChildren);
				item.collapse.destroy();
			});
		}

		this.inited = false;
	}

}

export default CollapsableNavigation;


// WEBPACK FOOTER //
// ./components/navigation/collapsable-navigation/c-collapsable-navigation.js